import React, { useEffect, useState } from 'react';
import { InternalApiAlertDecisionRule, InternalApiEntityType } from '../../api-internal';
import { decisionRulesApi } from '../../apis';
import { showFeedback } from '../../feedback/feedbackReducer';
import { useDispatch } from 'react-redux';
import DecisionRuleTable from './DecisionRuleTable';
import Tracker from '../../tracking/tracker';
import SalvPage from '../../common/SalvPage';
import { getConfigurationUrl } from '../../navigation/helper';
import { ConfigurationProduct } from '../../settings/configuration/Configuration';

const DecisionRules = () => {
  const dispatch = useDispatch();

  const [decisionRules, setDecisionRules] = useState<Array<InternalApiAlertDecisionRule>>();

  useEffect(() => {
    if (!decisionRules) {
      updateDecisionRules();
    }
  }, [decisionRules, setDecisionRules]);

  const updateDecisionRules = async () => {
    decisionRulesApi
      .findDecisionRules()
      .then((result) => {
        setDecisionRules(result);
      })
      .catch((e) => {
        Tracker.error(e);
        dispatch(
          showFeedback({
            message: 'Loading decision rules failed',
            success: false,
          })
        );
      });
  };

  return (
    <SalvPage
      title={'Decision rules'}
      breadcrumb={{
        title: 'Configuration',
        to: getConfigurationUrl(ConfigurationProduct.GENERAL),
      }}
    >
      <div className='m-b-8'>
        <span className='text-secondary'>Reach out to Salv to change the rules</span>
      </div>
      {decisionRules ? (
        <>
          <DecisionRuleTable type={InternalApiEntityType.TRANSACTION} rules={decisionRules} />
          <DecisionRuleTable type={InternalApiEntityType.PERSON} rules={decisionRules} />
        </>
      ) : (
        <span>loading</span>
      )}
    </SalvPage>
  );
};

export default DecisionRules;
